import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall, getBranches, getCustomers } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import subscriptionPermissionsControl from "../../components/SubscriptionPermissionsControl";
import "./ServiceAddWithAI.css";

const selectStyles = {
    control: (provided, state) => ({
        ...provided,
        minHeight: 48,
        borderRadius: 12,
        borderColor: state.isFocused ? "#2f6fed" : "#dfe6f1",
        backgroundColor: state.isDisabled ? "#f2f5f9" : "#fbfcfe",
        boxShadow: state.isFocused ? "0 0 0 3px rgba(47,111,237,.1)" : "none",
        "&:hover": { borderColor: state.isFocused ? "#2f6fed" : "#b9c7da" },
    }),
    valueContainer: (provided) => ({ ...provided, padding: "2px 14px" }),
    placeholder: (provided) => ({ ...provided, color: "#98a5b6" }),
    menu: (provided) => ({ ...provided, zIndex: 30, borderRadius: 12, overflow: "hidden" }),
};

export class ServiceAdd extends React.Component {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();
        this.customerInputRef = React.createRef();
        this.plateSearchTimer = null;
        this.plateRequestSequence = 0;
        this.state = {
            branches: [], customers: [], brands: [], models: [],
            loading: false, isLoad: true,
            selectedBrand: null, selectedModel: null, selectedCustomer: null,
            selectedExistingVehicle: null, isCustomerHasPID: false, isDisabled: false,
            filteredCustomers: [], showCustomerDropdown: false, showCustomerInfo: false,
            dropdownPlacement: "bottom", dropdownMaxHeight: 240, customer_name: "",
            plateResults: [], plateSearching: false, showPlateDropdown: false, plateSearchComplete: false,
            formData: {
                brand: "", model: "", plate: "", gen: "", name: "", surname: "",
                branch_id: "", km: "", vehicle_id: "", customer_id: "", save_parasut: 0,
            },
        };
    }

    async componentDidMount() {
        const initialPlate = new URLSearchParams(this.props.location?.search || '').get('plate') || '';
        if (/^[0-9A-Za-zÇĞİÖŞÜçğıöşü\s.-]{3,20}$/.test(initialPlate)) {
            this.setState(prev => ({ formData: { ...prev.formData, plate: this.normalizePlate(initialPlate) } }));
        }
        try {
            const [brandsResponse, branches, customersResponse] = await Promise.all([
                apiCall("business/vehicle/get-brands", "get", null), getBranches(), getCustomers(),
            ]);
            const customers = Array.isArray(customersResponse) ? customersResponse
                : Array.isArray(customersResponse?.data) ? customersResponse.data
                    : Array.isArray(customersResponse?.data?.data) ? customersResponse.data.data : [];
            this.setState({
                brands: (brandsResponse || []).map(brand => ({ value: brand.id, label: brand.name })),
                branches: branches || [], customers, isLoad: false,
            });
        } catch (error) {
            this.setState({ isLoad: false });
            mainHelper.toastMessage("error", "Form bilgileri yüklenemedi. Lütfen sayfayı yenileyin.");
        }
    }

    componentWillUnmount() {
        clearTimeout(this.plateSearchTimer);
        this.plateRequestSequence += 1;
    }

    normalizePlate = (value = "") => String(value).toLocaleUpperCase("tr-TR").replace(/[^0-9A-ZÇĞİÖŞÜ]/g, "").trim();

    customerLabel = (customer) => {
        if (!customer) return "Müşteri bilgisi bulunamadı";
        return customer.title || [customer.name, customer.surname].filter(Boolean).join(" ") || "İsimsiz müşteri";
    };

    getModels = async (brandId) => {
        const response = await apiCall(`business/vehicle/get-models/${brandId}`, "get", null);
        const models = (response || []).map(model => ({ value: model.id, label: model.name }));
        this.setState({ models });
        return models;
    };

    handleBrandChange = async (selectedBrand) => {
        this.setState(prevState => ({
            selectedBrand, selectedModel: null, models: [],
            formData: { ...prevState.formData, brand: selectedBrand?.value || "", model: "" },
        }));
        if (selectedBrand?.value) {
            try { await this.getModels(selectedBrand.value); }
            catch (error) { mainHelper.toastMessage("error", "Araç modelleri yüklenemedi."); }
        }
    };

    handleModelChange = (selectedModel) => this.setState(prevState => ({
        selectedModel,
        formData: { ...prevState.formData, model: selectedModel?.value || "" },
    }));

    searchVehiclesByPlate = async (plate) => {
        const normalizedPlate = this.normalizePlate(plate);
        if (normalizedPlate.length < 2) return;
        const requestId = ++this.plateRequestSequence;
        this.setState({ plateSearching: true, plateSearchComplete: false });
        try {
            const response = await apiCall(`business/vehicle/search-by-plate?query=${encodeURIComponent(normalizedPlate)}`, "get", null);
            if (requestId !== this.plateRequestSequence) return;
            const plateResults = Array.isArray(response?.data) ? response.data : [];
            const exactMatches = plateResults.filter(vehicle => this.normalizePlate(vehicle.plate) === normalizedPlate);
            if (exactMatches.length === 1) {
                await this.selectExistingVehicle(exactMatches[0]);
                return;
            }
            this.setState({ plateResults, plateSearching: false, plateSearchComplete: true, showPlateDropdown: true });
        } catch (error) {
            if (requestId === this.plateRequestSequence) {
                this.setState({ plateResults: [], plateSearching: false, plateSearchComplete: true, showPlateDropdown: false });
            }
        }
    };

    handlePlateChange = (event) => {
        const plate = event.target.value.toLocaleUpperCase("tr-TR");
        clearTimeout(this.plateSearchTimer);
        this.plateRequestSequence += 1;
        this.setState(prevState => ({
            formData: { ...prevState.formData, plate, vehicle_id: "" },
            plateResults: [], plateSearching: false, plateSearchComplete: false, showPlateDropdown: false,
        }));
        if (this.normalizePlate(plate).length >= 2) {
            this.plateSearchTimer = setTimeout(() => this.searchVehiclesByPlate(plate), 350);
        }
    };

    selectExistingVehicle = async (vehicle) => {
        clearTimeout(this.plateSearchTimer);
        this.plateRequestSequence += 1;
        let models = this.state.models;
        if (vehicle.brand?.id) {
            try { models = await this.getModels(vehicle.brand.id); }
            catch (error) { models = vehicle.model ? [{ value: vehicle.model.id, label: vehicle.model.name }] : []; }
        }
        const selectedBrand = vehicle.brand ? { value: vehicle.brand.id, label: vehicle.brand.name } : null;
        const selectedModel = vehicle.model ? { value: vehicle.model.id, label: vehicle.model.name } : null;
        const customer = vehicle.customer || null;
        this.setState(prevState => ({
            models, selectedBrand, selectedModel, selectedCustomer: customer,
            selectedExistingVehicle: vehicle, customer_name: this.customerLabel(customer),
            isCustomerHasPID: Boolean(customer?.p_id), isDisabled: true,
            plateResults: [], plateSearching: false, plateSearchComplete: true,
            showPlateDropdown: false, showCustomerDropdown: false, showCustomerInfo: false,
            formData: {
                ...prevState.formData,
                brand: vehicle.brand?.id || "", model: vehicle.model?.id || "",
                plate: vehicle.plate || prevState.formData.plate, gen: vehicle.gen || "",
                branch_id: vehicle.branch_id || prevState.formData.branch_id, km: "",
                vehicle_id: vehicle.id || vehicle.vehicle_id, customer_id: customer?.id || "",
                name: "", surname: "",
            },
        }));
    };

    releaseExistingVehicle = () => {
        this.setState(prevState => ({
            selectedExistingVehicle: null, selectedCustomer: null, selectedBrand: null, selectedModel: null,
            models: [], customer_name: "", isCustomerHasPID: false, isDisabled: false, plateSearchComplete: false,
            formData: {
                ...prevState.formData, brand: "", model: "", plate: "", gen: "", vehicle_id: "", customer_id: "", name: "", surname: "",
            },
        }));
    };

    handleButtonClick = () => this.fileInputRef.current?.click();
    handleFileChange = (event) => {
        const file = event.target.files?.[0];
        if (file) this.getVehiclesDataWithAI(file);
        event.target.value = null;
    };

    getVehiclesDataWithAI = async (file) => {
        try {
            Swal.fire({ title: "Resim işleniyor...", text: "Plaka ve araç bilgileri okunuyor.", icon: "info", allowOutsideClick: false, showConfirmButton: false, willOpen: () => Swal.showLoading() });
            const payload = new FormData();
            payload.append("file", file);
            const response = await axios.post("https://trafficeye.ai/recognition", payload, { headers: { apikey: process.env.REACT_APP_EYETRAFFIC_API_KEY } });
            const vehicleInfo = response?.data?.data?.combinations?.[0]?.roadUsers?.[0];
            const plateInfo = vehicleInfo?.plates?.[0];
            if (!vehicleInfo || plateInfo?.type?.value === "UNK" || Number(plateInfo?.text?.score || 0) < 0.5) throw new Error("INVALID_IMAGE");

            const plate = plateInfo?.text?.value;
            const brandName = vehicleInfo?.mmr?.make?.value;
            const modelName = vehicleInfo?.mmr?.model?.value;
            const generation = vehicleInfo?.mmr?.generation?.value?.split(" ")?.[0] || "";
            if (!plate) throw new Error("PLATE_NOT_FOUND");

            const existing = await apiCall(`business/vehicle/check-from-plate/${encodeURIComponent(plate)}`, "get", null);
            if (existing?.vehicle_id && existing?.customer) {
                await this.selectExistingVehicle({ ...existing, id: existing.vehicle_id });
                Swal.close();
                Swal.fire({ title: "Kayıtlı araç seçildi", text: `${existing.plate || plate} plakalı araç ve bağlı müşteri forma getirildi. Güncel km bilgisini girerek devam edin.`, icon: "success", confirmButtonText: "Tamam" });
                return;
            }

            const brand = await apiCall("business/vehicle/get-brands-by-name", "post", { brand: brandName });
            if (!brand) throw new Error("VEHICLE_NOT_MAPPED");
            const models = await this.getModels(brand.id);
            const model = await apiCall(`business/vehicle/get-models-by-name/${brand.id}`, "post", { model: modelName });
            if (!model) throw new Error("VEHICLE_NOT_MAPPED");
            this.setState(prevState => ({
                models, selectedBrand: { value: brand.id, label: brand.name }, selectedModel: { value: model.id, label: model.name }, isDisabled: false,
                formData: { ...prevState.formData, brand: brand.id, model: model.id, plate, gen: generation, vehicle_id: "" },
            }));
            Swal.close();
            Swal.fire({ title: "Araç bilgileri hazır", text: `${plate} · ${brand.name} ${model.name}. Bilgileri kontrol ederek devam edin.`, icon: "success", confirmButtonText: "Tamam" });
        } catch (error) {
            Swal.close();
            const mappingError = error?.message === "VEHICLE_NOT_MAPPED";
            Swal.fire({
                title: mappingError ? "Araç eşleştirilemedi" : "Fotoğraf okunamadı",
                text: mappingError ? "Marka veya model araç veritabanında bulunamadı. Bilgileri manuel seçerek devam edebilirsiniz." : "Plakanın net göründüğü bir fotoğraf deneyin veya bilgileri manuel girin.",
                icon: "warning", confirmButtonText: "Tamam",
            });
        }
    };

    normalizeCustomerSearch = (value = "") => String(value).toLocaleLowerCase("tr-TR").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ı/g, "i").replace(/\s+/g, " ").trim();
    filterCustomers = (value) => {
        const normalizedQuery = this.normalizeCustomerSearch(value);
        if (!normalizedQuery) return [];
        const queryParts = normalizedQuery.split(" ").filter(Boolean);
        return this.state.customers.filter(customer => {
            if (Number(customer?.is_supplier || 0) !== 0) return false;
            const searchText = this.normalizeCustomerSearch([customer?.name, customer?.surname, customer?.title, customer?.phone, customer?.email, customer?.tax_no].filter(Boolean).join(" "));
            return queryParts.every(part => searchText.includes(part));
        }).sort((first, second) => this.customerLabel(first).localeCompare(this.customerLabel(second), "tr-TR")).slice(0, 30);
    };

    updateCustomerDropdownPosition = () => {
        const input = this.customerInputRef.current;
        if (!input) return;
        const inputRect = input.getBoundingClientRect();
        const spaceBelow = window.innerHeight - inputRect.bottom;
        const spaceAbove = inputRect.top;
        const dropdownPlacement = spaceBelow < 220 && spaceAbove > spaceBelow ? "top" : "bottom";
        const availableSpace = dropdownPlacement === "top" ? spaceAbove : spaceBelow;
        this.setState({ dropdownPlacement, dropdownMaxHeight: Math.max(120, Math.min(280, availableSpace - 24)) });
    };

    handleCustomerFocus = () => {
        const filteredCustomers = this.filterCustomers(this.state.customer_name);
        this.setState({ filteredCustomers, showCustomerDropdown: filteredCustomers.length > 0 }, this.updateCustomerDropdownPosition);
    };

    handleCustomerInputChange = (event) => {
        const value = event.target.value;
        const filteredCustomers = this.filterCustomers(value);
        const nameParts = value.trim().split(/\s+/).filter(Boolean);
        const name = nameParts.shift() || "";
        const surname = nameParts.join(" ");
        this.setState(prevState => ({
            selectedCustomer: null, customer_name: value, filteredCustomers,
            showCustomerDropdown: filteredCustomers.length > 0,
            showCustomerInfo: Boolean(value) && filteredCustomers.length === 0,
            formData: { ...prevState.formData, customer_id: "", name, surname },
        }), this.updateCustomerDropdownPosition);
    };

    handleCustomerSelect = (customer) => this.setState(prevState => ({
        selectedCustomer: customer, customer_name: this.customerLabel(customer), filteredCustomers: [],
        showCustomerDropdown: false, showCustomerInfo: false, isCustomerHasPID: Boolean(customer?.p_id),
        formData: { ...prevState.formData, customer_id: customer.id, name: "", surname: "" },
    }));

    handleChange = (event) => {
        const { name, type, value, checked } = event.target;
        this.setState(prevState => ({ formData: { ...prevState.formData, [name]: type === "checkbox" ? checked : value } }));
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        this.setState({ loading: true });
        const serviceFormData = new FormData();
        Object.keys(this.state.formData).forEach(key => serviceFormData.append(key, this.state.formData[key]));
        try {
            const response = await apiCall("business/operation/add-with-ai", "post", serviceFormData);
            mainHelper.toastMessage(response.status, response.message);
            if (response.status === "success") {
                this.props.history.push(`${process.env.PUBLIC_URL}/services`);
                return;
            }
        } catch (error) {
            mainHelper.toastMessage("error", "Servis kaydı oluşturulamadı. Zorunlu alanları kontrol edin.");
        } finally { this.setState({ loading: false }); }
    };

    renderPlateSearchState() {
        const { formData, plateSearching, plateResults, plateSearchComplete, showPlateDropdown, selectedExistingVehicle } = this.state;
        const normalizedPlate = this.normalizePlate(formData.plate);
        if (selectedExistingVehicle) return <div className="sza-inline-status success"><i className="fa fa-check-circle" /><span><strong>Kayıtlı araç seçildi.</strong> Araç ve müşteri bilgileri mevcut kayıttan kullanılacak.</span></div>;
        if (plateSearching) return <div className="sza-inline-status"><i className="fa fa-circle-o-notch fa-spin" /><span>Kayıtlı plakalar aranıyor...</span></div>;
        if (plateSearchComplete && normalizedPlate.length >= 2 && plateResults.length === 0) return <div className="sza-inline-status new-record"><i className="fa fa-plus-circle" /><span><strong>Kayıtlı araç bulunamadı.</strong> Yeni araç ve seçtiğiniz müşteriyle devam edebilirsiniz.</span></div>;
        if (!showPlateDropdown || plateResults.length === 0) return null;
        return (
            <div className="sza-plate-results">
                <div className="sza-results-title">Eşleşen kayıtlı araçlar</div>
                {plateResults.map(vehicle => (
                    <button type="button" key={vehicle.id} className="sza-plate-result" onMouseDown={event => event.preventDefault()} onClick={() => this.selectExistingVehicle(vehicle)}>
                        <span className="sza-result-plate">{vehicle.plate}</span>
                        <span className="sza-result-copy"><strong>{[vehicle.brand?.name, vehicle.model?.name].filter(Boolean).join(" ") || "Araç bilgisi yok"}</strong><small>{this.customerLabel(vehicle.customer)}{vehicle.branch?.name ? ` · ${vehicle.branch.name}` : ""}</small></span>
                        <i className="fa fa-chevron-right" />
                    </button>
                ))}
            </div>
        );
    }

    render() {
        const { branches, loading, brands, models, selectedBrand, selectedModel, selectedCustomer, selectedExistingVehicle, isDisabled, formData } = this.state;
        const canUseAI = this.props.subscriptionCode !== "none" && this.props.subscriptionCode !== "t22Vh3S";
        const linkedCustomer = selectedExistingVehicle?.customer || selectedCustomer;
        return (
            <div className="sza-page" onClick={() => document.body.classList.remove("offcanvas-active")}>
                <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? "block" : "none" }}>
                    <div className="loader sza-page-loader"><img src={require("../../assets/images/logo-white.png")} width="150" alt="ServiceZone" /><p>Form hazırlanıyor</p><ReactLoading type="spin" width="24px" height="24px" color="#ffffff" /></div>
                </div>
                <div className="container-fluid">
                    <PageHeader HeaderText="Yeni Servis Kaydı" Breadcrumb={[{ name: "Servisler", navigate: "services" }, { name: "Yeni Servis", navigate: "" }]} />
                    <section className="sza-hero">
                        <div className="sza-hero-copy"><span className="sza-eyebrow"><i className="fa fa-magic" /> AKILLI SERVİS GİRİŞİ</span><h1>Aracı bulun, servisi saniyeler içinde açın.</h1><p>Plakayı yazın veya araç fotoğrafını okutun. Kayıtlı araç ve müşteri bilgileri otomatik eşleşsin.</p></div>
                        <div className="sza-hero-steps" aria-label="Servis kayıt adımları"><span className="active"><b>1</b> Araç</span><span><b>2</b> Müşteri</span><span><b>3</b> Servis</span></div>
                    </section>

                    <form className="sza-layout" onSubmit={this.handleSubmit} encType="multipart/form-data">
                        <aside className="sza-aside">
                            <div className="sza-ai-card">
                                <span className="sza-card-kicker">ALTERNATİF GİRİŞ</span><h2>Fotoğraftan tanı</h2><p>Plakanın net göründüğü bir araç fotoğrafıyla marka, model ve plakayı otomatik doldurun.</p>
                                <button disabled={!canUseAI} type="button" className="sza-camera-button" onClick={this.handleButtonClick}><span><i className="fa fa-camera" /></span><strong>Fotoğraf çek veya yükle</strong><small>JPG veya PNG</small></button>
                                <input disabled={!canUseAI} type="file" accept="image/jpeg,image/png,image/webp" capture="environment" ref={this.fileInputRef} hidden onChange={this.handleFileChange} />
                                {!canUseAI && <div className="sza-plan-note"><i className="fa fa-lock" /> Fotoğraftan tanıma için planınızı yükseltin.</div>}
                            </div>
                            <div className="sza-tip-card"><i className="fa fa-lightbulb-o" /><div><strong>En hızlı akış</strong><p>Önce plakayı yazın. Araç kayıtlıysa müşteri seçimi ve araç bilgileri otomatik kilitlenir.</p></div></div>
                        </aside>

                        <main className="sza-main">
                            <section className="sza-panel">
                                <div className="sza-section-heading"><div><span>01 / ARAÇ</span><h2>Araç bilgileri</h2><p>Plaka yazılırken mevcut araç kayıtları otomatik aranır.</p></div>{selectedExistingVehicle && <button type="button" className="sza-change-button" onClick={this.releaseExistingVehicle}><i className="fa fa-refresh" /> Seçimi değiştir</button>}</div>
                                <div className="sza-field sza-plate-field">
                                    <label htmlFor="plate">Plaka <em>*</em></label>
                                    <div className={`sza-input-wrap ${isDisabled ? "locked" : ""}`}><i className="fa fa-car" /><input name="plate" id="plate" type="text" disabled={isDisabled} value={formData.plate} onChange={this.handlePlateChange} onFocus={() => this.setState({ showPlateDropdown: this.state.plateResults.length > 0 })} onBlur={() => setTimeout(() => this.setState({ showPlateDropdown: false }), 120)} placeholder="Örn. 34 ABC 123" autoComplete="off" required />{isDisabled && <span className="sza-lock-label"><i className="fa fa-lock" /> Kayıtlı</span>}</div>
                                    {this.renderPlateSearchState()}
                                </div>
                                <div className="sza-form-grid">
                                    <div className="sza-field"><label>Marka <em>*</em></label><Select value={selectedBrand} onChange={this.handleBrandChange} options={brands} isDisabled={isDisabled} placeholder="Marka seçin" styles={selectStyles} noOptionsMessage={() => "Marka bulunamadı"} /></div>
                                    <div className="sza-field"><label>Model <em>*</em></label><Select value={selectedModel} onChange={this.handleModelChange} options={models} isDisabled={isDisabled || !selectedBrand} placeholder={selectedBrand ? "Model seçin" : "Önce marka seçin"} styles={selectStyles} noOptionsMessage={() => "Model bulunamadı"} /></div>
                                    <div className="sza-field"><label htmlFor="km">Güncel kilometre <em>*</em></label><div className="sza-input-wrap"><i className="fa fa-tachometer" /><input name="km" id="km" type="number" min="0" inputMode="numeric" value={formData.km} onWheel={event => event.currentTarget.blur()} onChange={this.handleChange} placeholder="Örn. 125000" required /></div></div>
                                    <div className="sza-field"><label htmlFor="branch_id">Servis şubesi <em>*</em></label><div className="sza-input-wrap"><i className="fa fa-map-marker" /><select name="branch_id" id="branch_id" value={formData.branch_id} onChange={this.handleChange} required><option value="">Şube seçin</option>{branches.map(branch => <option key={branch.id} value={branch.id}>{branch.name}</option>)}</select></div></div>
                                </div>
                            </section>

                            <section className="sza-panel">
                                <div className="sza-section-heading"><div><span>02 / MÜŞTERİ</span><h2>Müşteri bilgileri</h2><p>{isDisabled ? "Bu araçla ilişkili müşteri kaydı kullanılıyor." : "Mevcut müşteriyi arayın veya yeni müşteri adını yazın."}</p></div>{linkedCustomer && <span className="sza-selected-badge"><i className="fa fa-check" /> Seçildi</span>}</div>
                                <div className="sza-field sza-customer-field">
                                    <label htmlFor="customer_name">Müşteri <em>*</em></label>
                                    <div className={`sza-input-wrap ${isDisabled ? "locked" : ""}`}><i className="fa fa-user" /><input ref={this.customerInputRef} id="customer_name" type="text" disabled={isDisabled} value={this.state.customer_name} onChange={this.handleCustomerInputChange} onFocus={this.handleCustomerFocus} onBlur={() => setTimeout(() => this.setState({ showCustomerDropdown: false }), 120)} placeholder="Ad, soyad, telefon veya firma ara" autoComplete="off" required />{isDisabled && <span className="sza-lock-label"><i className="fa fa-lock" /> Bağlı kayıt</span>}</div>
                                    {this.state.showCustomerDropdown && <div className={`sza-customer-results ${this.state.dropdownPlacement}`} style={{ maxHeight: `${this.state.dropdownMaxHeight}px` }} onWheel={event => event.stopPropagation()}>{this.state.filteredCustomers.map(customer => <button type="button" key={customer.id} onMouseDown={event => event.preventDefault()} onClick={() => this.handleCustomerSelect(customer)}><span className="sza-avatar">{this.customerLabel(customer).charAt(0).toLocaleUpperCase("tr-TR")}</span><span><strong>{this.customerLabel(customer)}</strong><small>{[customer.phone, customer.email].filter(Boolean).join(" · ") || "İletişim bilgisi yok"}</small></span></button>)}</div>}
                                </div>
                                {linkedCustomer && <div className="sza-customer-summary"><div><span>Müşteri / Firma</span><strong>{this.customerLabel(linkedCustomer)}</strong></div><div><span>Telefon</span><strong>{linkedCustomer.phone || "Belirtilmemiş"}</strong></div><div><span>E-posta</span><strong>{linkedCustomer.email || "Belirtilmemiş"}</strong></div></div>}
                                {this.state.showCustomerInfo && <div className="sza-inline-status new-record"><i className="fa fa-user-plus" /><span><strong>Yeni müşteri oluşturulacak.</strong> Ad ve soyadı aralarında boşluk olacak şekilde eksiksiz yazın.</span></div>}
                            </section>

                            <div className="sza-submit-bar">
                                <div><i className="fa fa-shield" /><span><strong>Kontrollü kayıt</strong><small>Zorunlu alanları tamamladığınızda servis kaydı oluşturulur.</small></span></div>
                                <button type="submit" disabled={loading}>{loading ? <><i className="fa fa-circle-o-notch fa-spin" /> Kaydediliyor...</> : <><span>Servis kaydını oluştur</span><i className="fa fa-arrow-right" /></>}</button>
                            </div>
                        </main>
                    </form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({ isSecuritySystem: ioTReducer.isSecuritySystem });
export default subscriptionPermissionsControl(withRouter(connect(mapStateToProps, {})(ServiceAdd)));
